import script from "./ReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=4bf130cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf130cd"]])

export default __exports__